<div>
    <div>
        <form #incomeForm="ngForm" novalidate="novalidate" autocomplete="off" (keydown.enter)="$event.preventDefault()">

            <div class="row mb-5 justify-content-md-center">
                <div class="col-lg-10 col-md-12">
                    <div class="color-secondary-gray font-size-16 font-weight-bold mb-3">
                        Please provide revenue and expense information for the Company for the time periods
                        specified
                        below.
                    </div>
                </div>
            </div>

            <ng-container *ngIf="currentReport?.LATEST">

                <!-- #region "fiscal-year-end" -->
                <div class="row my-5 justify-content-md-center" *ngIf="!currentReport.LATEST.INCOME_STATEMENT.length">
                    <div class="col-lg-10 col-md-12">

                        <div class="label">What Is the Company's fiscal year end?</div>
                        <app-custom-datepicker [minDateString]="'1901-1-1'" [maxDateString]="fyeMaxDate"
                            [twoMonthMode]="!common.isTabletDevice && !common.isMobileDevice" [dateOutFormat]="'MMMM DD'" [dateInFormat]="'YYYY-MM-DD'"
                            [dateValue]="currentReport.LATEST.FYE_DATE" [(ngModel)]="currentReport.LATEST.FYE_DATE"
                            (ngModelChange)="callUpdateVersionDetailsAPI('FYE_DATE')" #FYE_DATE="ngModel"
                            name="FYE_DATE" required [isYearVisible]="false" [disabled]="currentReport.isLocked"
                            [displayFormat]="'MMMM dd'" placeholder="mm/dd" [showOnlyCurrentYear]="true"
                            [isDisable]="currentReport.LATEST.INCOME_STATEMENT.length ? true : false">
                        </app-custom-datepicker>

                    </div>
                </div>
                <!-- #endregion -->

                <!-- #region "recent-financials" -->
                <div class="row my-5 justify-content-md-center"
                    *ngIf="!currentReport.LATEST.INCOME_STATEMENT.length && currentReport.LATEST.FYE_DATE">
                    <div class="col-lg-10 col-md-12" *ngIf="refreshDate">

                        <div class="label">Please select the date of the Company’s most recent financials</div>
                        <div class="color-secondary-gray font-size-14 font-weight-normal mb-3">Interim financial
                            date</div>

                        <app-custom-datepicker [minDateString]="'1900-1-1'" [maxDateString]="toDayDate"
                            [twoMonthMode]="!common.isTabletDevice && !common.isMobileDevice" [dateOutFormat]="'MMMM DD, YYYY'" [dateInFormat]="'YYYY-MM-DD'"
                            [dateValue]="currentReport.LATEST.RECENT_FINANCIAL_DATE" [isDisable]="disabledRecentFinancialDate || currentReport.isLocked"
                            [displayFormat]="'MMMM dd, yyyy'" placeholder="mm/dd/yyyy"
                            [(ngModel)]="currentReport.LATEST.RECENT_FINANCIAL_DATE" #RECENT_FINANCIAL_DATE="ngModel"
                            name="RECENT_FINANCIAL_DATE" required>
                        </app-custom-datepicker>

                    </div>
                </div>
                <!-- #endregion -->

                <!-- #region income-table -->
                <div class="row my-5 IS__page" *ngIf="currentReport.LATEST.INCOME_STATEMENT.length">
                    <div class="col-md-12">

                        <div class="row border__bottom">

                            <div class="col-6 col-md-4 col-lg-3 table-side-container">
                                <div class="header top"></div>
                                <div class="header">Type of Financials</div>
                                <div class="header">Number of Months</div>
                                <div class="header">Revenue</div>
                                <div class="header d-block">
                                    <div>Profit Before Taxes</div><small>(Tax Return not Book)</small>
                                </div>
                                <div class="header">Add: Interest</div>
                                <div class="header">Add: Depreciation</div>
                                <div class="header">Add: Amortization</div>
                                <div class="header">Add: All Owner’s Compensation</div>
                                <div class="header" *ngIf="isForm1065">Add: Guaranteed Payment to Partners</div>
                                <div class="header">Net Income + Owner’s Salary</div>
                            </div>

                            <div class="col-6 col-md-8 col-lg-9 p-0">
                                <div
                                    class="d-flex flex-nowrap table__body custom__scroll vertical__Scroll overflow-y-hidden">
                                    <div class="table-column" *ngFor="let it of incomeTable; let i = index"
                                        style="min-width: 150px; width: 100%;"
                                        [ngStyle]="{'max-width': hasInterim && it.IS_TYPE == isTypeEnum.FORECASTED ? 'auto' : !hasInterim ? 'auto' : '150px'}">

                                        <div class="table-column-header"
                                            *ngIf="it.IS_TYPE != isTypeEnum.FORECASTED && it.IS_TYPE != isTypeEnum.INTERIM">
                                            {{it.YEAR}}
                                        </div>
                                        <div class="table-column-header px-1"
                                            *ngIf="it.IS_TYPE != isTypeEnum.FORECASTED && it.IS_TYPE == isTypeEnum.INTERIM">
                                            <button class="button secondary__button p-3 m-auto font-size-20"
                                                (click)="changeRecentFinDate()" [disabled]="currentReport.isLocked">
                                                {{it.FYE_DATE | date: 'MM-dd-yyyy'}}
                                            </button>
                                        </div>
                                        <div class="table-column-header btn-group px-1"
                                            *ngIf="it.IS_TYPE == isTypeEnum.FORECASTED" dropdown placement="right">
                                            <button id="dropdown-alignment-forecasted" dropdownToggle
                                                class="button ghost__button color--gray--2 p-0 font-size-20 h-100 ddl__btn position-absolute"
                                                aria-controls="dropdown-alignment-forecasted">
                                                <span class="mr-4">{{it.FYE_DATE | date: 'MM-dd-yyyy'}}</span> <em
                                                    class="fa fa-ellipsis-h font-size-14"></em>
                                            </button>
                                            <div id="dropdown-alignment" *dropdownMenu
                                                class="dropdown-menu dropdown-menu-right" role="menu"
                                                aria-labelledby="dropdown-alignment">
                                                <div role="menuitem"
                                                    *ngIf="!currentReport.LATEST.ASSISTED_INTERIM_CALCULATION">
                                                    <button class="dropdown-item color--blue" [disabled]="currentReport.isLocked"
                                                        (click)="changeAutomaticallyManually()">
                                                        Calculate automatically
                                                    </button>
                                                </div>
                                                <div role="menuitem">
                                                    <button class="dropdown-item color--gray--2" [disabled]="currentReport.isLocked"
                                                        (click)="showHowForecastingWorks()">
                                                        How forecasting works
                                                    </button>
                                                </div>
                                                <div role="menuitem">
                                                    <button class="dropdown-item color--red" [disabled]="currentReport.isLocked"
                                                        (click)="removeInterimClick()">
                                                        Remove interim
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Financial Type -->
                                        <div class="table-column-cell border-top-0">
                                            <ng-container *ngIf="it.IS_TYPE != isTypeEnum.FORECASTED">
                                                <div class="withOut__margin"
                                                    [ngClass]="{'input__error': (FINANCIAL_TYPE.errors && (FINANCIAL_TYPE.dirty || FINANCIAL_TYPE.touched))}">
                                                    <app-custom-select #FINANCIAL_TYPE="ngModel"
                                                        [(ngModel)]="it.FINANCIAL_TYPE"
                                                        [disabled]="it.IS_TYPE == isTypeEnum.FORECASTED || currentReport.isLocked" [values]="statementType"
                                                        placeholder="Choose" size="sm" name="FINANCIAL_TYPE_{{i}}"
                                                        id="FINANCIAL_TYPE_{{i}}" class="no-bottom-border"
                                                        (valueSelected)="callUpdateAPI('FINANCIAL_TYPE', it)"
                                                        [required]="true" [hideOption]="it.IS_TYPE == isTypeEnum.INTERIM"
                                                        [isToolTip]="true">
                                                    </app-custom-select>
                                                </div>
                                            </ng-container>
                                            <ng-container *ngIf="it.IS_TYPE == isTypeEnum.FORECASTED">
                                                <input type="text" id="income-fore-casted" class="input silent-input"
                                                    disabled [value]="'Forecasted'">
                                            </ng-container>
                                        </div>

                                        <!-- Months -->
                                        <div class="table-column-cell">
                                            <ng-container
                                                *ngIf="it.FINANCIAL_TYPE != 'NOT_AVAILABLE' && (it.IS_TYPE != isTypeEnum.FORECASTED && it.IS_TYPE != isTypeEnum.INTERIM)">
                                                <app-custom-select #MONTHS="ngModel" [(ngModel)]="it.MONTHS"
                                                    [values]="monthList" placeholder="Choose" size="sm"
                                                    [disabled]="!it.FINANCIAL_TYPE || currentReport.isLocked" name="MONTHS_{{i}}"
                                                    id="MONTHS_{{i}}" (valueSelected)="callUpdateAPI('MONTHS', it)">
                                                </app-custom-select>
                                            </ng-container>
                                            <ng-container
                                                *ngIf="it.FINANCIAL_TYPE != 'NOT_AVAILABLE' && (it.IS_TYPE == isTypeEnum.FORECASTED || it.IS_TYPE == isTypeEnum.INTERIM)">
                                                <input type="text" id="income-months" class="input silent-input"
                                                    disabled [value]="it.MONTHS + ' Months'">
                                            </ng-container>
                                            <ng-container *ngIf="it.FINANCIAL_TYPE == 'NOT_AVAILABLE'">
                                                <input type="text" id="income-financial-not-available-months"
                                                    class="input silent-input" disabled [value]="'N/A'">
                                            </ng-container>
                                        </div>

                                        <!-- Revenue -->
                                        <div class="table-column-cell">
                                            <ng-container
                                                *ngIf="it.FINANCIAL_TYPE != 'NOT_AVAILABLE' && refreshRevenue">

                                                <div *ngIf="it.IS_TYPE == isTypeEnum.FORECASTED"
                                                    [ngClass]="{'input__error': (REVENUE.errors && (REVENUE.dirty || REVENUE.touched))}">

                                                    <ist-action-context-menu [columnName]="'REVENUE'" #revenueContext
                                                        [versionId]="currentReport.LATEST.ID"
                                                        [activeAction]="currentReport.LATEST.INCOME_STATEMENT_FUNCTIONS.REVENUE"
                                                        [revenuePercentage]="currentReport.LATEST.IS_INCREASE_PERCENTAGE"
                                                        [isClickable]="it.IS_TYPE == isTypeEnum.FORECASTED"
                                                        (percentDialogOpen)="percentDialogOpen = $event">

                                                        <div class="d-flex align-items-center">

                                                            <app-ist-action-list-option (clickAction)="!currentReport.isLocked ? revenueContext.toggleContextMenu($event) : null"
                                                                [activeAction]="currentReport.LATEST.INCOME_STATEMENT_FUNCTIONS.REVENUE">
                                                            </app-ist-action-list-option>

                                                            <number-input [(ngModel)]="it.REVENUE"
                                                                [classes]="'input silent-input'"
                                                                #REVENUE="ngModel"
                                                                [required]="(it.IS_TYPE == isTypeEnum.HISTORICAL && 1 == 1) || (it.IS_TYPE == isTypeEnum.INTERIM && currentReport.LATEST.INCOME_STATEMENT_FUNCTIONS.REVENUE != 'LAST_YEAR')"
                                                                name="REVENUE_{{i}}"
                                                                id="REVENUE_{{i}}"
                                                                [disabled]="currentReport.isLocked || !it.FINANCIAL_TYPE || (it.IS_TYPE == isTypeEnum.FORECASTED && currentReport.LATEST.ASSISTED_INTERIM_CALCULATION)"
                                                                (blur)=" showRevenueWarning(it); callUpdateAPI('REVENUE', it);"
                                                                [allowNegative]="true"></number-input>

                                                            <ist-margin [revenue]="it.REVENUE"
                                                                [fieldValue]="getLastHistoricalRevenue()"
                                                                [isForecastedYear]="true"
                                                                [selectedMonth]="getSelectedMonth(it)"
                                                                [lastHistoricalMonth]="getLastHistoricalMonth()">
                                                            </ist-margin>

                                                        </div>

                                                    </ist-action-context-menu>

                                                </div>

                                                <div *ngIf="it.IS_TYPE != isTypeEnum.FORECASTED"
                                                    [ngClass]="{'input__error': (REVENUE.errors && (REVENUE.dirty || REVENUE.touched))}">

                                                    <div class="withOut__margin">

                                                        <number-input [(ngModel)]="it.REVENUE"
                                                            [classes]="'input silent-input'"
                                                            #REVENUE="ngModel"
                                                            [required]="(it.IS_TYPE == isTypeEnum.HISTORICAL && 1 == 1) || (it.IS_TYPE == isTypeEnum.INTERIM && currentReport.LATEST.INCOME_STATEMENT_FUNCTIONS.REVENUE != 'LAST_YEAR')"
                                                            name="REVENUE_{{i}}"
                                                            id="REVENUE_{{i}}"
                                                            [disabled]="currentReport.isLocked || !it.FINANCIAL_TYPE || (it.IS_TYPE == isTypeEnum.FORECASTED && currentReport.LATEST.ASSISTED_INTERIM_CALCULATION)"
                                                            (blur)="showRevenueWarning(it); callUpdateAPI('REVENUE', it);"
                                                            [allowNegative]="true"></number-input>

                                                    </div>

                                                </div>



                                            </ng-container>
                                            <ng-container *ngIf="it.FINANCIAL_TYPE == 'NOT_AVAILABLE'">
                                                <input type="text" id="income-financial-type-not-available"
                                                    class="input silent-input" disabled [value]="'0'">
                                            </ng-container>
                                        </div>

                                        <ng-container
                                            *ngIf="(it.IS_TYPE == isTypeEnum.INTERIM && !currentReport.LATEST.ASSISTED_INTERIM_CALCULATION) || (it.IS_TYPE != isTypeEnum.INTERIM && 1 == 1)">
                                            <!-- Profit -->
                                            <div class="table-column-cell">
                                                <ng-container *ngIf="it.FINANCIAL_TYPE != 'NOT_AVAILABLE'">

                                                    <ng-container *ngIf="it.IS_TYPE == isTypeEnum.FORECASTED">

                                                        <ist-action-context-menu [columnName]="'PROFIT'" #profitContext
                                                            [versionId]="currentReport.LATEST.ID"
                                                            [activeAction]="currentReport.LATEST.INCOME_STATEMENT_FUNCTIONS.PROFIT"
                                                            [historicalVisible]="checkNotAvailableFinType()"
                                                            [isClickable]="it.IS_TYPE == isTypeEnum.FORECASTED && !currentReport.LATEST.ASSISTED_INTERIM_CALCULATION">

                                                            <div class="d-flex align-items-center">

                                                                <app-ist-action-list-option (clickAction)="!currentReport.isLocked ? profitContext.toggleContextMenu($event) : null"
                                                                    *ngIf="!currentReport.LATEST.ASSISTED_INTERIM_CALCULATION"
                                                                    [activeAction]="currentReport.LATEST.INCOME_STATEMENT_FUNCTIONS.PROFIT">
                                                                </app-ist-action-list-option>

                                                                <number-input [(ngModel)]="it.PROFIT"
                                                                    [classes]="'input silent-input'"
                                                                    #PROFIT="ngModel"
                                                                    [required]="false"
                                                                    name="PROFIT_{{i}}"
                                                                    id="PROFIT_{{i}}"
                                                                    [class.margin__left__28]="currentReport.LATEST.ASSISTED_INTERIM_CALCULATION && it.IS_TYPE == isTypeEnum.FORECASTED"
                                                                    [disabled]="currentReport.isLocked || !it.FINANCIAL_TYPE || (it.IS_TYPE == isTypeEnum.FORECASTED && currentReport.LATEST.ASSISTED_INTERIM_CALCULATION)"
                                                                    (blur)="callUpdateAPI('PROFIT', it)"
                                                                    [allowNegative]="true"></number-input>

                                                                <ist-margin [revenue]="it.REVENUE"
                                                                    [fieldValue]="it.PROFIT"
                                                                    [selectedMonth]="getSelectedMonth(it)"></ist-margin>

                                                            </div>
                                                        </ist-action-context-menu>

                                                    </ng-container>

                                                    <ng-container *ngIf="it.IS_TYPE != isTypeEnum.FORECASTED">

                                                        <div class="d-flex align-items-center">

                                                            <number-input [(ngModel)]="it.PROFIT"
                                                                [classes]="'input silent-input'"
                                                                #PROFIT="ngModel"
                                                                [required]="false"
                                                                name="PROFIT_{{i}}"
                                                                id="PROFIT_{{i}}"
                                                                [class.margin__left__28]="currentReport.LATEST.ASSISTED_INTERIM_CALCULATION && it.IS_TYPE == isTypeEnum.FORECASTED"
                                                                [disabled]="currentReport.isLocked || !it.FINANCIAL_TYPE || (it.IS_TYPE == isTypeEnum.FORECASTED && currentReport.LATEST.ASSISTED_INTERIM_CALCULATION)"
                                                                (blur)="callUpdateAPI('PROFIT', it)"
                                                                [allowNegative]="true"></number-input>

                                                            <ist-margin [revenue]="it.REVENUE" [fieldValue]="it.PROFIT"
                                                                [selectedMonth]="getSelectedMonth(it)"></ist-margin>

                                                        </div>

                                                    </ng-container>

                                                </ng-container>
                                                <ng-container *ngIf="it.FINANCIAL_TYPE == 'NOT_AVAILABLE'">
                                                    <input type="text" id="income-financial-not-available"
                                                        class="input silent-input" disabled [value]="'0'">
                                                </ng-container>
                                            </div>

                                            <!-- Interest -->
                                            <div class="table-column-cell">
                                                <ng-container *ngIf="it.FINANCIAL_TYPE != 'NOT_AVAILABLE'">

                                                    <ng-container *ngIf="it.IS_TYPE == isTypeEnum.FORECASTED">

                                                        <ist-action-context-menu [columnName]="'INTEREST'" #interestContext
                                                            [versionId]="currentReport.LATEST.ID"
                                                            [activeAction]="currentReport.LATEST.INCOME_STATEMENT_FUNCTIONS.INTEREST"
                                                            [historicalVisible]="checkNotAvailableFinType()"
                                                            [isClickable]="it.IS_TYPE == isTypeEnum.FORECASTED && !currentReport.LATEST.ASSISTED_INTERIM_CALCULATION">

                                                            <div class="d-flex align-items-center">

                                                                <app-ist-action-list-option (clickAction)="!currentReport.isLocked ? interestContext.toggleContextMenu($event) : null"
                                                                    *ngIf="!currentReport.LATEST.ASSISTED_INTERIM_CALCULATION"
                                                                    [activeAction]="currentReport.LATEST.INCOME_STATEMENT_FUNCTIONS.INTEREST">
                                                                </app-ist-action-list-option>

                                                                <number-input [(ngModel)]="it.INTEREST"
                                                                    [classes]="'input silent-input'"
                                                                    #INTEREST="ngModel"
                                                                    [required]="false"
                                                                    name="INTEREST_{{i}}"
                                                                    id="INTEREST_{{i}}"
                                                                    [class.margin__left__28]="currentReport.LATEST.ASSISTED_INTERIM_CALCULATION && it.IS_TYPE == isTypeEnum.FORECASTED"
                                                                    [disabled]="currentReport.isLocked || !it.FINANCIAL_TYPE || (it.IS_TYPE == isTypeEnum.FORECASTED && currentReport.LATEST.ASSISTED_INTERIM_CALCULATION)"
                                                                    (blur)="callUpdateAPI('INTEREST', it)"
                                                                    [allowNegative]="true"></number-input>

                                                                <ist-margin [revenue]="it.REVENUE"
                                                                    [fieldValue]="it.INTEREST"
                                                                    [selectedMonth]="getSelectedMonth(it)"></ist-margin>

                                                            </div>
                                                        </ist-action-context-menu>

                                                    </ng-container>

                                                    <ng-container *ngIf="it.IS_TYPE != isTypeEnum.FORECASTED">

                                                        <div class="d-flex align-items-center">

                                                            <number-input [(ngModel)]="it.INTEREST"
                                                                [classes]="'input silent-input'"
                                                                #INTEREST="ngModel"
                                                                [required]="false"
                                                                name="INTEREST_{{i}}"
                                                                id="INTEREST_{{i}}"
                                                                [class.margin__left__28]="currentReport.LATEST.ASSISTED_INTERIM_CALCULATION && it.IS_TYPE == isTypeEnum.FORECASTED"
                                                                [disabled]="currentReport.isLocked || !it.FINANCIAL_TYPE || (it.IS_TYPE == isTypeEnum.FORECASTED && currentReport.LATEST.ASSISTED_INTERIM_CALCULATION)"
                                                                (blur)="callUpdateAPI('INTEREST', it)"
                                                                [allowNegative]="true"></number-input>

                                                            <ist-margin [revenue]="it.REVENUE"
                                                                [fieldValue]="it.INTEREST"
                                                                [selectedMonth]="getSelectedMonth(it)"></ist-margin>

                                                        </div>

                                                    </ng-container>

                                                </ng-container>
                                                <ng-container *ngIf="it.FINANCIAL_TYPE == 'NOT_AVAILABLE'">
                                                    <input type="text" class="input silent-input" disabled
                                                        [value]="'0'">
                                                </ng-container>
                                            </div>

                                            <!-- Depreciation -->
                                            <div class="table-column-cell">
                                                <ng-container *ngIf="it.FINANCIAL_TYPE != 'NOT_AVAILABLE'">

                                                    <ng-container *ngIf="it.IS_TYPE == isTypeEnum.FORECASTED">

                                                        <ist-action-context-menu [columnName]="'DEPRECIATION'" #depreciationContext
                                                            [versionId]="currentReport.LATEST.ID"
                                                            [activeAction]="currentReport.LATEST.INCOME_STATEMENT_FUNCTIONS.DEPRECIATION"
                                                            [historicalVisible]="checkNotAvailableFinType()"
                                                            [isClickable]="it.IS_TYPE == isTypeEnum.FORECASTED && !currentReport.LATEST.ASSISTED_INTERIM_CALCULATION">

                                                            <div class="d-flex align-items-center">

                                                                <app-ist-action-list-option (clickAction)="!currentReport.isLocked ? depreciationContext.toggleContextMenu($event) : null"
                                                                    *ngIf="!currentReport.LATEST.ASSISTED_INTERIM_CALCULATION"
                                                                    [activeAction]="currentReport.LATEST.INCOME_STATEMENT_FUNCTIONS.DEPRECIATION">
                                                                </app-ist-action-list-option>

                                                                <number-input [(ngModel)]="it.DEPRECIATION"
                                                                    [classes]="'input silent-input'"
                                                                    #DEPRECIATION="ngModel"
                                                                    [required]="false"
                                                                    name="DEPRECIATION_{{i}}"
                                                                    id="DEPRECIATION_{{i}}"
                                                                    [class.margin__left__28]="currentReport.LATEST.ASSISTED_INTERIM_CALCULATION && it.IS_TYPE == isTypeEnum.FORECASTED"
                                                                    [disabled]="currentReport.isLocked || !it.FINANCIAL_TYPE || (it.IS_TYPE == isTypeEnum.FORECASTED && currentReport.LATEST.ASSISTED_INTERIM_CALCULATION)"
                                                                    (blur)="callUpdateAPI('DEPRECIATION', it)"
                                                                    [allowNegative]="true"></number-input>

                                                                <ist-margin [revenue]="it.REVENUE"
                                                                    [fieldValue]="it.DEPRECIATION"
                                                                    [selectedMonth]="getSelectedMonth(it)"></ist-margin>

                                                            </div>
                                                        </ist-action-context-menu>

                                                    </ng-container>

                                                    <ng-container *ngIf="it.IS_TYPE != isTypeEnum.FORECASTED">

                                                        <div class="d-flex align-items-center">

                                                            <number-input [(ngModel)]="it.DEPRECIATION"
                                                                [classes]="'input silent-input'"
                                                                #DEPRECIATION="ngModel"
                                                                [required]="false"
                                                                name="DEPRECIATION_{{i}}"
                                                                id="DEPRECIATION_{{i}}"
                                                                [class.margin__left__28]="currentReport.LATEST.ASSISTED_INTERIM_CALCULATION && it.IS_TYPE == isTypeEnum.FORECASTED"
                                                                [disabled]="currentReport.isLocked || !it.FINANCIAL_TYPE || (it.IS_TYPE == isTypeEnum.FORECASTED && currentReport.LATEST.ASSISTED_INTERIM_CALCULATION)"
                                                                (blur)="callUpdateAPI('DEPRECIATION', it)"
                                                                [allowNegative]="true"></number-input>

                                                            <ist-margin [revenue]="it.REVENUE"
                                                                [fieldValue]="it.DEPRECIATION"
                                                                [selectedMonth]="getSelectedMonth(it)"></ist-margin>

                                                        </div>

                                                    </ng-container>

                                                </ng-container>
                                                <ng-container *ngIf="it.FINANCIAL_TYPE == 'NOT_AVAILABLE'">
                                                    <input id="income-financial-not-available" type="text"
                                                        class="input silent-input" disabled [value]="'0'">
                                                </ng-container>
                                            </div>

                                            <!-- Amortization -->
                                            <div class="table-column-cell">
                                                <ng-container *ngIf="it.FINANCIAL_TYPE != 'NOT_AVAILABLE'">

                                                    <ng-container *ngIf="it.IS_TYPE == isTypeEnum.FORECASTED">

                                                        <ist-action-context-menu [columnName]="'AMORTIZATION'" #amortizationContext
                                                            [versionId]="currentReport.LATEST.ID"
                                                            [activeAction]="currentReport.LATEST.INCOME_STATEMENT_FUNCTIONS.AMORTIZATION"
                                                            [historicalVisible]="checkNotAvailableFinType()"
                                                            [isClickable]="it.IS_TYPE == isTypeEnum.FORECASTED && !currentReport.LATEST.ASSISTED_INTERIM_CALCULATION">

                                                            <div class="d-flex align-items-center">

                                                                <app-ist-action-list-option (clickAction)="!currentReport.isLocked ? amortizationContext.toggleContextMenu($event) : null"
                                                                    *ngIf="!currentReport.LATEST.ASSISTED_INTERIM_CALCULATION"
                                                                    [activeAction]="currentReport.LATEST.INCOME_STATEMENT_FUNCTIONS.AMORTIZATION">
                                                                </app-ist-action-list-option>

                                                                <number-input [(ngModel)]="it.AMORTIZATION"
                                                                    [classes]="'input silent-input'"
                                                                    #AMORTIZATION="ngModel"
                                                                    [required]="false"
                                                                    name="AMORTIZATION_{{i}}"
                                                                    id="AMORTIZATION_{{i}}"
                                                                    [class.margin__left__28]="currentReport.LATEST.ASSISTED_INTERIM_CALCULATION && it.IS_TYPE == isTypeEnum.FORECASTED"
                                                                    [disabled]="currentReport.isLocked || !it.FINANCIAL_TYPE || (it.IS_TYPE == isTypeEnum.FORECASTED && currentReport.LATEST.ASSISTED_INTERIM_CALCULATION)"
                                                                    (blur)="callUpdateAPI('AMORTIZATION', it)"
                                                                    [allowNegative]="true"></number-input>

                                                                <ist-margin [revenue]="it.REVENUE"
                                                                    [fieldValue]="it.AMORTIZATION"
                                                                    [selectedMonth]="getSelectedMonth(it)"></ist-margin>

                                                            </div>
                                                        </ist-action-context-menu>

                                                    </ng-container>

                                                    <ng-container *ngIf="it.IS_TYPE != isTypeEnum.FORECASTED">

                                                        <div class="d-flex align-items-center">

                                                            <number-input [(ngModel)]="it.AMORTIZATION"
                                                                [classes]="'input silent-input'"
                                                                #AMORTIZATION="ngModel"
                                                                [required]="false"
                                                                name="AMORTIZATION_{{i}}"
                                                                id="AMORTIZATION_{{i}}"
                                                                [class.margin__left__28]="currentReport.LATEST.ASSISTED_INTERIM_CALCULATION && it.IS_TYPE == isTypeEnum.FORECASTED"
                                                                [disabled]="currentReport.isLocked || !it.FINANCIAL_TYPE || (it.IS_TYPE == isTypeEnum.FORECASTED && currentReport.LATEST.ASSISTED_INTERIM_CALCULATION)"
                                                                (blur)="callUpdateAPI('AMORTIZATION', it)"
                                                                [allowNegative]="true"></number-input>

                                                            <ist-margin [revenue]="it.REVENUE"
                                                                [fieldValue]="it.AMORTIZATION"
                                                                [selectedMonth]="getSelectedMonth(it)"></ist-margin>

                                                        </div>

                                                    </ng-container>

                                                </ng-container>
                                                <ng-container *ngIf="it.FINANCIAL_TYPE == 'NOT_AVAILABLE'">
                                                    <input type="text" id="income-financial-deprication-not-available"
                                                        class="input silent-input" disabled [value]="'0'">
                                                </ng-container>
                                            </div>

                                            <!-- Officer Comp -->
                                            <div class="table-column-cell">
                                                <ng-container *ngIf="it.FINANCIAL_TYPE != 'NOT_AVAILABLE'">

                                                    <ng-container *ngIf="it.IS_TYPE == isTypeEnum.FORECASTED">

                                                        <ist-action-context-menu [columnName]="'OFFICER_COMP'" #officerCompContext
                                                            [versionId]="currentReport.LATEST.ID"
                                                            [activeAction]="currentReport.LATEST.INCOME_STATEMENT_FUNCTIONS.OFFICER_COMP"
                                                            [historicalVisible]="checkNotAvailableFinType()"
                                                            [isClickable]="it.IS_TYPE == isTypeEnum.FORECASTED && !currentReport.LATEST.ASSISTED_INTERIM_CALCULATION">

                                                            <div class="d-flex align-items-center">

                                                                <app-ist-action-list-option (clickAction)="!currentReport.isLocked ? officerCompContext.toggleContextMenu($event) : null"
                                                                    *ngIf="!currentReport.LATEST.ASSISTED_INTERIM_CALCULATION"
                                                                    [activeAction]="currentReport.LATEST.INCOME_STATEMENT_FUNCTIONS.OFFICER_COMP">
                                                                </app-ist-action-list-option>

                                                                <number-input [(ngModel)]="it.OFFICER_COMP"
                                                                    [classes]="'input silent-input'"
                                                                    #AMORTIZATION="ngModel"
                                                                    [required]="false"
                                                                    name="OFFICER_COMP_{{i}}"
                                                                    id="OFFICER_COMP_{{i}}"
                                                                    [class.margin__left__28]="currentReport.LATEST.ASSISTED_INTERIM_CALCULATION && it.IS_TYPE == isTypeEnum.FORECASTED"
                                                                    [disabled]="currentReport.isLocked || !it.FINANCIAL_TYPE || (it.IS_TYPE == isTypeEnum.FORECASTED && currentReport.LATEST.ASSISTED_INTERIM_CALCULATION)"
                                                                    (blur)="callUpdateAPI('OFFICER_COMP', it)"
                                                                    [allowNegative]="true"></number-input>

                                                                <ist-margin [revenue]="it.REVENUE"
                                                                    [fieldValue]="it.OFFICER_COMP"
                                                                    [selectedMonth]="getSelectedMonth(it)"></ist-margin>

                                                            </div>
                                                        </ist-action-context-menu>

                                                    </ng-container>

                                                    <ng-container *ngIf="it.IS_TYPE != isTypeEnum.FORECASTED">

                                                        <div class="d-flex align-items-center">

                                                            <number-input [(ngModel)]="it.OFFICER_COMP"
                                                                [classes]="'input silent-input'"
                                                                #AMORTIZATION="ngModel"
                                                                [required]="false"
                                                                name="OFFICER_COMP_{{i}}"
                                                                id="OFFICER_COMP_{{i}}"
                                                                [class.margin__left__28]="currentReport.LATEST.ASSISTED_INTERIM_CALCULATION && it.IS_TYPE == isTypeEnum.FORECASTED"
                                                                [disabled]="currentReport.isLocked || !it.FINANCIAL_TYPE || (it.IS_TYPE == isTypeEnum.FORECASTED && currentReport.LATEST.ASSISTED_INTERIM_CALCULATION)"
                                                                (blur)="callUpdateAPI('OFFICER_COMP', it)"
                                                                [allowNegative]="true"></number-input>

                                                            <ist-margin [revenue]="it.REVENUE"
                                                                [fieldValue]="it.OFFICER_COMP"
                                                                [selectedMonth]="getSelectedMonth(it)"></ist-margin>

                                                        </div>

                                                    </ng-container>

                                                </ng-container>
                                                <ng-container *ngIf="it.FINANCIAL_TYPE == 'NOT_AVAILABLE'">
                                                    <input type="text" id="income-financial-type-officer-comp"
                                                        class="input silent-input" disabled [value]="'0'">
                                                </ng-container>
                                            </div>

                                            <!-- GUARANTEED PAYMENTS -->
                                            <div class="table-column-cell" *ngIf="isForm1065">
                                                <ng-container *ngIf="it.FINANCIAL_TYPE != 'NOT_AVAILABLE'">

                                                    <ng-container *ngIf="it.IS_TYPE == isTypeEnum.FORECASTED">

                                                        <ist-action-context-menu [columnName]="'GUARANTEED_PAYMENTS'" #guaranteedPaymentsContext
                                                            [versionId]="currentReport.LATEST.ID"
                                                            [activeAction]="currentReport.LATEST.INCOME_STATEMENT_FUNCTIONS.GUARANTEED_PAYMENTS"
                                                            [historicalVisible]="checkNotAvailableFinType()"
                                                            [isClickable]="it.IS_TYPE == isTypeEnum.FORECASTED && !currentReport.LATEST.ASSISTED_INTERIM_CALCULATION">

                                                            <div class="d-flex align-items-center">

                                                                <app-ist-action-list-option (clickAction)="!currentReport.isLocked ? guaranteedPaymentsContext.toggleContextMenu($event) : null"
                                                                    *ngIf="!currentReport.LATEST.ASSISTED_INTERIM_CALCULATION"
                                                                    [activeAction]="currentReport.LATEST.INCOME_STATEMENT_FUNCTIONS.GUARANTEED_PAYMENTS">
                                                                </app-ist-action-list-option>

                                                                <number-input [(ngModel)]="it.GUARANTEED_PAYMENTS"
                                                                    [classes]="'input silent-input'"
                                                                    #GUARANTEED_PAYMENTS="ngModel"
                                                                    [required]="false"
                                                                    name="GUARANTEED_PAYMENTS_{{i}}"
                                                                    id="GUARANTEED_PAYMENTS_{{i}}"
                                                                    [class.margin__left__28]="currentReport.LATEST.ASSISTED_INTERIM_CALCULATION && it.IS_TYPE == isTypeEnum.FORECASTED"
                                                                    [disabled]="currentReport.isLocked || !it.FINANCIAL_TYPE || (it.IS_TYPE == isTypeEnum.FORECASTED && currentReport.LATEST.ASSISTED_INTERIM_CALCULATION)"
                                                                    (blur)="callUpdateAPI('GUARANTEED_PAYMENTS', it)"
                                                                    [allowNegative]="true"></number-input>

                                                                <ist-margin [revenue]="it.REVENUE"
                                                                    [fieldValue]="it.GUARANTEED_PAYMENTS"
                                                                    [selectedMonth]="getSelectedMonth(it)"></ist-margin>

                                                            </div>
                                                        </ist-action-context-menu>

                                                    </ng-container>

                                                    <ng-container *ngIf="it.IS_TYPE != isTypeEnum.FORECASTED">

                                                        <div class="d-flex align-items-center">

                                                            <number-input [(ngModel)]="it.GUARANTEED_PAYMENTS"
                                                                    [classes]="'input silent-input'"
                                                                    #GUARANTEED_PAYMENTS="ngModel"
                                                                    [required]="false"
                                                                    name="GUARANTEED_PAYMENTS_{{i}}"
                                                                    id="GUARANTEED_PAYMENTS_{{i}}"
                                                                    [class.margin__left__28]="currentReport.LATEST.ASSISTED_INTERIM_CALCULATION && it.IS_TYPE == isTypeEnum.FORECASTED"
                                                                    [disabled]="currentReport.isLocked || !it.FINANCIAL_TYPE || (it.IS_TYPE == isTypeEnum.FORECASTED && currentReport.LATEST.ASSISTED_INTERIM_CALCULATION)"
                                                                    (blur)="callUpdateAPI('GUARANTEED_PAYMENTS', it)"
                                                                    [allowNegative]="true"></number-input>

                                                            <ist-margin [revenue]="it.REVENUE"
                                                                [fieldValue]="it.GUARANTEED_PAYMENTS"
                                                                [selectedMonth]="getSelectedMonth(it)"></ist-margin>

                                                        </div>

                                                    </ng-container>

                                                </ng-container>
                                                <ng-container *ngIf="it.FINANCIAL_TYPE == 'NOT_AVAILABLE'">
                                                    <input type="text" class="input silent-input"
                                                        id="income-financial-type-guaranteed-payments-comp" disabled
                                                        [value]="'0'">
                                                </ng-container>
                                            </div>

                                            <!-- Total Calculation -->
                                            <div class="table-column-cell">
                                                <ng-container *ngIf="it.FINANCIAL_TYPE != 'NOT_AVAILABLE'">
                                                    <div class="d-flex align-items-center">
                                                        <div class="margin"
                                                            [class.margin__left__28]="it.IS_TYPE == isTypeEnum.FORECASTED">
                                                            <div class="input silent-input total__row">
                                                                {{calculateTotal(it) | number}}
                                                            </div>
                                                        </div>
                                                        <ist-margin [revenue]="it.REVENUE"
                                                            [fieldValue]="calculateTotal(it)"
                                                            [selectedMonth]="getSelectedMonth(it)"></ist-margin>
                                                    </div>
                                                </ng-container>
                                                <ng-container *ngIf="it.FINANCIAL_TYPE == 'NOT_AVAILABLE'">
                                                    <input type="text" class="input silent-input"
                                                        id="income-financial-type-total-calculation-comp" disabled
                                                        [value]="'0'">
                                                </ng-container>
                                            </div>
                                        </ng-container>

                                        <ng-container
                                            *ngIf="it.IS_TYPE == isTypeEnum.INTERIM && currentReport.LATEST.ASSISTED_INTERIM_CALCULATION">
                                            <div class="automatically__manually__box">
                                                <p>Now the forecast is calculated automatically</p>
                                                <span>
                                                    The interim revenue is annualized and appears in the right column.
                                                    All expenses have been projected based on their prior year’s
                                                    percentage of sales (sales margin) according to the projected
                                                    revenues.
                                                </span>
                                                <div class="text-center">
                                                    <button id="income-financial-type-enter-manully-payments-comp"
                                                        class="button secondary__button medium__button"
                                                            [disabled]="currentReport.isLocked"
                                                        (click)="changeAutomaticallyManually()">Enter Manually</button>
                                                </div>
                                            </div>
                                        </ng-container>

                                    </div>

                                </div>
                            </div>

                        </div>

                        <div class="row" *ngIf="hasInterim">
                            <div class="col-md-3"></div>
                            <div class="col-md-9 p-0">
                                <div class="table-column float-right diff__column__border" style="min-width: 187px;">
                                    <div class="table-column-cell">
                                        <div class="font-size-12 text-center pt-1"
                                            [ngClass]="{'negative': getDifferencePercentage() < 0, 'positive': getDifferencePercentage() > 0}">
                                            <div>Difference vs Last Year:</div>
                                            <div class="font-size-16" *ngIf="getDifferencePercentage() > 999">>999%
                                            </div>
                                            <div class="font-size-16" *ngIf="getDifferencePercentage() <= 999">
                                                <span
                                                    *ngIf="getDifferencePercentage() < -999;else percentage_span">&lt;-999%</span>
                                                <ng-template #percentage_span>{{getDifferencePercentage()}}%
                                                </ng-template>
                                                <!-- {{getDifferencePercentage() < -999 ? '&lt;-999' : getDifferencePercentage()}}% -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row my-3">

                            <button id="income-paste-from-excel" class="button primary__button mr-3"
                                (click)="pasteExcel()" [disabled]="currentReport.isLocked">
                                Paste from Excel
                            </button>
                            <button id="income-import-from-excel" class="button primary__button mr-3"
                                (click)="importExcel()" [disabled]="currentReport.isLocked">
                                Import from Excel
                            </button>
                            <button id="income-finding-fields-open-modal" [disabled]="currentReport.isLocked"
                                class="button secondary__button icon__right mr-3" (click)="openHelpModal()">
                                Click Here for Help Finding These Fields
                            </button>
                            <button *ngIf="!hasInterim" id="income-add-interim" [disabled]="currentReport.isLocked"
                                class="button secondary__button icon__right mr-3" (click)="addInterimClick()">
                                Add Interim
                            </button>
                        </div>

                    </div>
                </div>
                <!-- #endregion -->

            </ng-container>

        </form>

    </div>
</div>
<report-footer [nextBtnEnable]="!incomeForm.invalid" (buttonClicked)="footerButtonClick($event)"
    [extraAvailable]="currentReport?.LATEST?.INCOME_STATEMENT.length && !currentReport?.isLocked"
    [extraBtnText]="common.isMobileDevice ? 'Reset' : 'Reset Income Statements'" [pageId]="reportPageConst.INCOME"
               [mobileIcon]="'reset-icon'">
</report-footer>
